module.exports = __webpack_public_path__ + "img/D201808_2.2a065598.jpg";